// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export var DUMMY_FUNCTION = function () { };
export var SML_SIZE;
(function (SML_SIZE) {
    SML_SIZE["S"] = "small";
    SML_SIZE["M"] = "medium";
    SML_SIZE["L"] = "large";
})(SML_SIZE || (SML_SIZE = {}));
export var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export var INDIA_PHONE_CODE = '+91';
export var MILLIS_IN_DAY = 1000 * 60 * 60 * 24;
export var MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export var SHORT_MONTHS = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
export var DOCUMENT_ACTION_TYPES;
(function (DOCUMENT_ACTION_TYPES) {
    DOCUMENT_ACTION_TYPES["DOWNLOAD"] = "DOWNLOAD";
    DOCUMENT_ACTION_TYPES["VIEW"] = "VIEW";
    DOCUMENT_ACTION_TYPES["EDIT"] = "EDIT";
    DOCUMENT_ACTION_TYPES["DELETE"] = "DELETE";
    DOCUMENT_ACTION_TYPES["UPLOAD"] = "UPLOAD";
})(DOCUMENT_ACTION_TYPES || (DOCUMENT_ACTION_TYPES = {}));
export var APP_DOMAIN;
(function (APP_DOMAIN) {
    APP_DOMAIN["LEAP"] = "Leap";
    APP_DOMAIN["GEEBEE"] = "Geebee";
})(APP_DOMAIN || (APP_DOMAIN = {}));
export var STATE_TYPES;
(function (STATE_TYPES) {
    STATE_TYPES["DEFAULT"] = "DEFAULT";
    STATE_TYPES["ACTIVE"] = "ACTIVE";
    STATE_TYPES["ERRORED"] = "ERRORED";
})(STATE_TYPES || (STATE_TYPES = {}));
export var POSITIONS;
(function (POSITIONS) {
    POSITIONS["LEFT"] = "LEFT";
    POSITIONS["RIGHT"] = "RIGHT";
    POSITIONS["TOP"] = "TOP";
    POSITIONS["BOTTOM"] = "BOTTOM";
})(POSITIONS || (POSITIONS = {}));
export var ACCEPTABLE_FILE_UPLOAD_TYPES = 'image/*,application/pdf,application/msword,application/vnd.ms-excel,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export var defaultInputPadding = '12px';
export var buttonInputPadding = '0.1rem 1rem';
export var BOOKMARK_ACTION_TYPES = {
    RENAME: 'RENAME',
    DUPLICATE: 'DUPLICATE',
    ARCHIVE: 'ARCHIVE',
    UNARCHIVE: 'UNARCHIVE'
};
export var STUDENT_PROFILE_ENUM;
(function (STUDENT_PROFILE_ENUM) {
    STUDENT_PROFILE_ENUM["Brilliant"] = "Brilliant";
    STUDENT_PROFILE_ENUM["Average"] = "Average";
    STUDENT_PROFILE_ENUM["Decent"] = "Decent";
})(STUDENT_PROFILE_ENUM || (STUDENT_PROFILE_ENUM = {}));
//# sourceMappingURL=common.js.map